import { ProjectAuditTab } from "@/components/blocks/audit/project-audit-tab";

import { useProjectDetailsContext } from "../context";

export function AuditTab() {
  const ctx = useProjectDetailsContext();
  // Destructure all needed values from context
  const {
    project,
    numericProjectId,
    auditInvoices,
    completionAuditEntries,
    auditCategoryFilter, clientAuditEvents,
    invoiceSendAuditEvents,
    // Additional items that may be used
  } = ctx;

  // Merge all client-side audit event sources.
  // TODO (Engineering): Remove this merge once all events come from the real API.
  const allExtraEvents = [...clientAuditEvents, ...invoiceSendAuditEvents];

  return (
    <>
                <ProjectAuditTab
                  projectId={numericProjectId || undefined}
                  projectCode={project?.code ?? String(project?.id ?? '')}
                  projectType={project?.type ?? ''}
                  billingTriggerType={project?.billingTriggerType}
                  completionAuditEntries={completionAuditEntries}
                  fixedFeeInvoices={project?.type === 'fixed-price' ? auditInvoices : []}
                  initialCategoryFilter={auditCategoryFilter as "all" | "completion" | "status" | "financial" | "billing" | "invoice" | "budget"}
                  extraEvents={allExtraEvents}
                />

    </>
  );
}
